export const htBreakpoints = {
  tablet: 415,
  desktop: 769,
  tabletV2: 600,
  desktopV2: 840,
};
